import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'
import classnames from 'classnames'

import {
  Button as ButtonComponent,
  BadgeComponent,
} from '../../../../components'
import useFeatures from '../../../../hooks/useFeatures'

import { JoinToSpeakBadgeFeature } from './join-to-speak-badge'

import './WebinarSidebarActionButtonsComponent.scss'

const WebinarSidebarActionButtonsComponent = ({
  onActivityClick,
  onQuestionsClick,
  onHandoutsClick,
  onPeopleClick,
  unreadChatCount,
  unreadQuestionsCount,
  accentColor,
  currentlySelectedSecondaryPanel,
}) => {
  const { HasJoinToSpeakEnabled } = useFeatures()

  const chatButtonLabel = intl.formatMessage({ defaultMessage: 'Chat' })

  return (
    <div className="webinar-sidebar-action-buttons-component">
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel': !currentlySelectedSecondaryPanel,
        })}
      >
        <ButtonComponent
          onClick={onActivityClick}
          color="transparent"
          className="action-button activity"
          ariaLabel={chatButtonLabel}
          size="small"
        >
          <BadgeComponent color={accentColor} count={unreadChatCount}>
            {chatButtonLabel}
          </BadgeComponent>
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'questions',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'questions'
              ? onQuestionsClick
              : undefined
          }
          color="transparent"
          className="action-button questions"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'Questions',
          })}
          size="small"
        >
          <BadgeComponent color={accentColor} count={unreadQuestionsCount}>
            <FormattedMessage defaultMessage="Questions" />
          </BadgeComponent>
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'handouts',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'handouts'
              ? onHandoutsClick
              : undefined
          }
          color="transparent"
          className="action-button"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'Handouts',
          })}
          size="small"
        >
          <FormattedMessage defaultMessage="Handouts" />
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'people',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'people'
              ? onPeopleClick
              : undefined
          }
          color="transparent"
          className="action-button people"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'People',
          })}
          size="small"
        >
          <JoinToSpeakBadgeFeature
            isEnabled={HasJoinToSpeakEnabled}
            color={accentColor}
          >
            <FormattedMessage defaultMessage="People" />
          </JoinToSpeakBadgeFeature>
        </ButtonComponent>
      </div>
    </div>
  )
}

WebinarSidebarActionButtonsComponent.propTypes = {
  onActivityClick: PropTypes.func,
  onQuestionsClick: PropTypes.func,
  onHandoutsClick: PropTypes.func,
  onPeopleClick: PropTypes.func,
  unreadChatCount: PropTypes.number,
  unreadQuestionsCount: PropTypes.number,
  accentColor: PropTypes.string,
  currentlySelectedSecondaryPanel: PropTypes.oneOf([
    'questions',
    'people',
    'handouts',
    'sessions',
    'playback',
  ]),
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarSidebarActionButtonsComponent
